export const EhWidgetEventType = {
    ModuleLoaded: "[EH] Module Loaded",
    ModuleLinkClicked: "[EH] Module Link Clicked",
} as const;
